import { render, staticRenderFns } from "./SensorHistory.vue?vue&type=template&id=328742da&scoped=true&"
import script from "./SensorHistory.vue?vue&type=script&lang=js&"
export * from "./SensorHistory.vue?vue&type=script&lang=js&"
import style0 from "./SensorHistory.vue?vue&type=style&index=0&id=328742da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328742da",
  null
  
)

export default component.exports